export const TestId = {
  LABEL_ID: 'label-id',
  INPUT_ID: 'input-id'
};
